import Intersect from 'vuetify/lib/directives/intersect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-box"},[_c('div',{staticClass:"articles-box"},_vm._l((_vm.displayedArticles),function(article){return _c('article-sum',{key:article.id,ref:"imgCard",refInFor:true,attrs:{"article":article,"identified":_vm.identified}})}),1),_c('div',{directives:[{def: Intersect,name:"intersect",rawName:"v-intersect",value:(_vm.infiniteScrolling),expression:"infiniteScrolling"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }